import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { ChevronDown } from 'lucide-react';

export const CollapsibleCard = ({
  title,
  description,
  icon: Icon,
  defaultOpen = false,
  headerAction,
  className = '',
  titleClassName = '',
  testId,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Card className={className} data-testid={testId}>
      <div
        role="button"
        tabIndex={0}
        onClick={() => setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setOpen((o) => !o);
          }
        }}
        className="cursor-pointer select-none"
        data-testid={testId ? `${testId}-toggle` : undefined}
        aria-expanded={open}
      >
        <CardHeader>
          <div className="flex items-center justify-between gap-3">
            <div className={`flex items-center gap-2 ${titleClassName}`}>
              {Icon && <Icon className="w-5 h-5" />}
              <CardTitle>{title}</CardTitle>
            </div>
            <div className="flex items-center gap-2">
              {headerAction && (
                <div onClick={(e) => e.stopPropagation()}>{headerAction}</div>
              )}
              <ChevronDown
                className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
              />
            </div>
          </div>
          {description && <CardDescription className="mt-1">{description}</CardDescription>}
        </CardHeader>
      </div>
      {open && children}
    </Card>
  );
};

export default CollapsibleCard;
